import { P } from '@workramp/ui';
import styled from 'styled-components';

export const StyledCharacterLimit = styled(P)`
  text-align: right;
  color: ${({ theme }) => theme.colors.on[600]};
  margin-top: ${({ theme }) => theme.spacing(2)}px;
`;
